import {
  FooterBlockType,
  LayoutOptions,
  MenuItem,
  processLayoutOptions,
  MediaProp,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...{
    dynamicCopyright: LayoutOptions.Boolean,
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type SocialIcon = {
  icon: string;
  url: string;
};

export type DefaultType = {
  logo: MediaProp;
  bottomLinks: MenuItem[];
  copyright: string;
  bottomIcons: SocialIcon[];
} & FooterBlockType<LayoutProps>;
